<gipi-abstract-form id="dialogRegisterClientClassification"
                    name="dialogRegisterClientClassification"
                    [dialog]="true">
    <gipi-toolbar mat-dialog-title
                  id="toolbarDialogRegisterClientClassification">
        Cadastrar classificação de cliente
    </gipi-toolbar>
    <div mat-dialog-content
         fxLayout="column"
         fxLayoutGap="16px">
        <div fxLayout="row"
             fxLayout.lt-sm="column"
             fxLayoutGap="16px">
            <itss-input label="Descrição"
                        id="clientClassificationDescription"
                        name="clientClassificationDescription"
                        [required]="true"
                        [disabled]="loading || (typeOperation === 'VIEW')"
                        [(ngModel)]="clientClassification.description"
                        [min]="3"
                        [max]="30"
                        [maxlength]="30"
                        fxFlex
                        fxFlex.lt-md="100">
            </itss-input>
            <gipi-input-select-enum label="Situação"
                                    id="clientClassificationEnabled"
                                    name="clientClassificationEnabled"
                                    [disabled]="loading || (typeOperation !== 'EDIT')"
                                    [required]="true"
                                    [valuesExclud]="[]"
                                    [enum]="optionActiveSituationEnum"
                                    [(ngModel)]="optionActiveSituationValue"
                                    fxFlex="30"
                                    fxFlex.lt-md="100">
            </gipi-input-select-enum>
        </div>
        <div fxLayout="row"
             fxLayout.lt-md="column"
             fxLayoutGap="16px">
            <itss-textarea label="Mensagem financeira"
                           id="clientClassificationFinancialMessage"
                           name="clientClassificationFinancialMessage"
                           [disabled]="loading || (typeOperation === 'VIEW')"
                           [(ngModel)]="clientClassification.financialMessage"
                           [rows]="4"
                           [maxlength]="100"
                           fxFlex
                           fxFlex.lt-md="100">
            </itss-textarea>
            <itss-textarea label="Observação financeira"
                           id="clientClassificationFinancialObservation"
                           name="clientClassificationFinancialObservation"
                           [disabled]="loading || (typeOperation === 'VIEW')"
                           [(ngModel)]="clientClassification.financialObservation"
                           [rows]="4"
                           [maxlength]="100"
                           fxFlex
                           fxFlex.lt-md="100">
            </itss-textarea>
        </div>
    </div>
    <div mat-dialog-actions
         fxLayout="row"
         fxLayoutAlign="end center"
         fxLayoutGap="16px">
        <gipi-button label="Salvar"
                     gipi-primary
                     id="btnSave"
                     name="btnSave"
                     *ngIf="(typeOperation !== 'VIEW')"
                     (click)="confirm()"
                     [disabled]="loading"
                     [loading]="loading"
                     fxFlex="30"
                     fxFlex.lt-md="100">
        </gipi-button>
        <gipi-button label="Voltar"
                     gipi-secondary
                     id="btnReturn"
                     name="btnReturn"
                     (click)="close('NONE')"
                     fxFlex="30"
                     fxFlex.lt-md="100">
        </gipi-button>
    </div>
</gipi-abstract-form>
